__turbopack_context__.v({
  "note": "ArticleVideoDock-module__6_E86a__note",
  "panels": "ArticleVideoDock-module__6_E86a__panels",
  "tools": "ArticleVideoDock-module__6_E86a__tools",
});
